import {NgModule} from '@angular/core';
import {provideRouter, RouterModule, Routes, withComponentInputBinding} from '@angular/router';

import {AuthGuard} from './api/guards/auth.guard';
import {AdminRoleGuard} from './api/guards/admin-role.guard';

import {ImprintComponent} from './components/welcome/imprint/imprint.component';
import {PrivacyComponent} from './components/welcome/privacy/privacy.component';
import {LoginComponent} from './components/login/login.component';
import {HomeComponent} from './components/home/home.component';
import {SurveyDetailComponent} from './components/survey-list/survey-detail/survey-detail.component';
import {ShibLoginComponent} from './components/shib-login/shib-login.component';
import {WelcomeComponent} from "./components/welcome/welcome.component";
import {SurveyPreferencesComponent} from "./components/survey-list/survey-preferences/survey-preferences.component";
import {DashboardComponent} from "./components/dashboard/dashboard.component";

const routes: Routes = [
  {
    path: 'privacy',
    component: PrivacyComponent
  },
  {
    path: 'imprint',
    component: ImprintComponent
  },
  {
    path: 'welcome',
    component: WelcomeComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'shib-login',
    component: ShibLoginComponent
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'surveys/:surveyId/assignment',
    component: SurveyDetailComponent,
    canActivate: [AuthGuard, AdminRoleGuard]
  },
  {
    path: 'surveys/:surveyId/dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard, AdminRoleGuard]
  },
  {
    path: 'surveys/:surveyId/preferences',
    component: SurveyPreferencesComponent,
    canActivate: [AuthGuard, AdminRoleGuard]
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [provideRouter(routes, withComponentInputBinding())]
})
export class AppRoutingModule {}
